<template>
  <q-modal v-model="showLogin">
    <div class="layout-padding">

      <div class="modal-close">
        <q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/')"></q-btn>
      </div>

      <div class="q-py-lg">

        <template v-if="!user">
          <form @submit.prevent="login(slug)"
                class="gutter-xs q-pa-xs">

            <div class="text-center"><img :src="logo" width="200px"/></div>

            <!-- Msisdn -->
            <v-input path="msisdn"
                     :label="$t('Number')"
                     v-model.number="form.msisdn"
                     type="number"
                     color="highlight"
                     id="login-msisdn"
                     :form="form">
            </v-input>

            <!-- Submit Button -->
            <div class="row justify-center">
              <v-submit :label="$t('log in')"
                        :loadingLabel="$t('validating...')"
                        color="primary"
                        :form="form">
              </v-submit>
            </div>

          </form>

          <template slot="actions">
            <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
                   :label="$T('forgot your password?')"></q-btn>
          </template>
        </template>

        <div v-else class="q-pa-xl text-center">
          {{ $T('you are logged in!') }}
        </div>

      </div>
    </div>
  </q-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import Form from 'vform'
import {QModal, QSpinnerPuff, QBtn, QCheckbox, QInput, Cookies} from 'quasar-framework'
import VInput from "../../components/form/VInput";

export default {
  name: 'VLogin',
  components: {
    VInput,
    QModal,
    QBtn,
    QSpinnerPuff,
    QCheckbox,
    QInput
  },

  data: () => ({
    form: new Form({
      msisdn: '',
      redirectTo: this.slug,
    }),
    logo: `${config.Url}${config.devAssetsFolder}/img/kamba-logo.png`
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      settings: 'local/settings'
    }),
    showLogin: {
      get() {
        return this.settings('login')
      },
      set(value) {
        this.$store.dispatch('local/set', {key: 'login', value})
      }
    },
    slug: {
      get() {
        return this.settings('redirect-route')
      },
      set(value) {
        this.$store.dispatch('local/set', {key: 'redirect-route', value})
      }
    },
  },

  methods: {
    redirectToWapBilling() {

      axios.get(`${config.appUrl}/service-url`)
          .then(({data}) => {
            window.location.href = data;
          })
    },
    async login(slug) {
      this.form.redirectTo = (slug !== undefined) ? slug : "/";
      this.form.portal = Cookies.get('portal');
      if(this.form.msisdn.toString().length === 0) {
        this.$q.notify({
          color: 'negative',
          icon: 'error',
          message: "Inform the number",
          detail: "try again!",
          position: 'top',
        })
      } else {
        // Submit the form.
        if(!this.$route.query.hasOwnProperty('error_n'))
        {
          const {data} = await this.form.post(`${config.SkySMSUrl}/login`)
          {
            window.location.href = data;
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue